
import React from 'react';
import LoansLedger from '@/components/accounting/LoansLedger';

export const LoansTab = () => {
  return <LoansLedger />;
};
